<template>
  <component
    :is="menuComponent"
    :item="item"
    :route-children="routeChildren"
    >
    <template v-if="item.children && item.children.length>0">
      <MenuTreePc
        v-for="route in item.children"
        :key="route.code"
        :item="route"
      />
    </template>
    <!-- 
        :full-path="handlePath(route.code)"
      <el-submenu v-if="item.children && item.children.length > 0" :index="item.code">
      <template #title>
        <span>{{ item.name }}</span>
      </template>
      <template v-for="child in item.children" >
        <MenuTreePc :item="child" :key="child.code"/>
      </template>
    </el-submenu>
    <el-menu-item v-else :index="item.code">{{ item.name }}</el-menu-item> -->
  </component>
</template>

<script>
// import path from 'path'
import MenuTreePc from './MenuTreePc.vue'
import VabSubmenu from './VabSubmenu'
import VabMenuItem from './VabMenuItem'

export default {
  name:'MenuTreePc',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    MenuTreePc,
    VabSubmenu,
    VabMenuItem,
  },
  computed: {
    menuComponent() {
      if (
        this.handleChildren(this.item.children, this.item) &&
        (!this.routeChildren.children || this.routeChildren.notShowChildren) 
      ) {
        return 'VabMenuItem'
      } else {
        return 'VabSubmenu'
      }
    },
  },
  data() {
    return {
      routeChildren: {},
    }
  },
  methods: {
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
    handleChildren(children = [], parent) {
      if (children === null) children = []
      const showChildren = children.filter((item) => {
        this.routeChildren = item
        return true
      })
      if (showChildren.length === 1) {
        return true
      }
      if (showChildren.length === 0) {
        this.routeChildren = {
          ...parent,
          path: '',
          notShowChildren: true,
        }
        return true
      }
      return false
    },
    handlePath(routePath) {
      if (this.isExternal(routePath)) {
        return routePath
      }
      if (this.isExternal(this.fullPath)) {
        return this.fullPath
      }
      return path.resolve(this.fullPath, routePath)
    },
  },
};
</script>
